module.exports = __webpack_public_path__ + "img/house-person-leave.57f7dd41.svg";